// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"M1-z"};